export default "__VITE_ASSET__CYGSMkY6__"